// @flow
import React, { Component } from 'react';

export default class Button extends Component<Props> {
    constructor(props) {
        super(props);

        this.state = {
            hover: false,
        };
    }

    toggleHover = () => {
        this.setState({
            hover: !this.state.hover,
        });
    };

    render() {
        let backgroundColor = this.props.backgroundColor
            ? this.props.backgroundColor
            : '#00aae6';
        let transform;
        let boxShadow;

        if (this.state.hover || this.props.isLoading) {
            transform = 'translateY(-2px)';
            boxShadow = '0px 1px 5px 1px rgba(0, 0, 0, 0.1)';
        }

        const {
            touched,
            errors,
            form,
            terms,
            discountAmount,
            invalidVoucher,
            invalid,
            isFromPayment,
        } = this.props;

        const isEnabled =
            isFromPayment && isFromPayment
                ? !invalidVoucher
                : !invalid &&
                  !errors &&
                  (form === 'registerForm'
                      ? form === 'registerForm' && terms
                      : true);

        return isEnabled ? (
            <button
                type="submit"
                style={{
                    backgroundColor: backgroundColor,
                    color: '#fff',
                    border: `solid 1px ${backgroundColor}`,
                    transform: transform,
                    boxShadow: boxShadow,
                    position: 'relative',
                }}
                onMouseOver={this.toggleHover}
                onMouseOut={this.toggleHover}
            >
                <span className="buttonlabel" />
                {this.props.text}
                {this.props.isLoading && (
                    <svg
                        className="spinner"
                        viewBox="0 0 66 66"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle
                            className="path"
                            fill="none"
                            strokeWidth="6"
                            strokeLinecap="round"
                            cx="33"
                            cy="33"
                            r="30"
                            stroke="#fff"
                        />
                    </svg>
                )}
            </button>
        ) : (
            <button
                type="submit"
                style={{
                    border: `solid 1px ${this.props.backgroundColor}`,
                    color: this.props.backgroundColor,
                }}
                disabled
            >
                <span className="buttonlabel" />
                {this.props.text}
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/ui/components/Inputs/Button.js